import { IconContainer } from "./TrashIcon.styles"

export interface TrashIconProps {
    iconWidth?: number;
    iconHeight?: number;
    iconColor?: string;
    containerSize?: number;
    containerBackgroundColor?: string;
    containerBorderColor?: string;
    containerBorderWidth?: number;
    className?: string;
}

const TrashIcon: React.FC<TrashIconProps> = ({
    iconWidth = 10,
    iconHeight = 11,
    iconColor = "#0022E6",
    containerSize,
    containerBackgroundColor,
    containerBorderColor,
    containerBorderWidth,
    className
}) => {
    return (
        <IconContainer
            className={className}
            $size={containerSize}
            $backgroundColor={containerBackgroundColor}
            $borderColor={containerBorderColor}
            $borderWidth={containerBorderWidth}
        >
            <svg width={iconWidth} height={iconHeight} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 3.75L11.3495 12.8569C11.2934 13.6418 10.6403 14.25 9.85332 14.25H3.64668C2.85972 14.25 2.20656 13.6418 2.15049 12.8569L1.5 3.75M5.25 6.75V11.25M8.25 6.75V11.25M9 3.75V1.5C9 1.08579 8.66421 0.75 8.25 0.75H5.25C4.83579 0.75 4.5 1.08579 4.5 1.5V3.75M0.75 3.75H12.75" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        </IconContainer>
    )
}

export default TrashIcon
